import { PuzzleUserAnswer } from '@/types/Puzzle'
import { defineStore } from 'pinia'
import { puzzleCorrectAnswers } from '@/data/puzzle'

interface PuzzleState {
  userAnswers: PuzzleUserAnswer[]
  currentVideoId: string | null
}

export const useStorePuzzle = defineStore('puzzleStore', {
  state: (): PuzzleState => {
    return {
      userAnswers: [],
      currentVideoId: null,
    }
  },

  getters: {
    showJustification: (state) => state.userAnswers.length !== 0,
    isUserAnswersCorrect: (state) => {
      if (state.userAnswers.length === 0) {
        return null
      }

      let nbrWrongAnswers = 0
      state.userAnswers.forEach((userAnswer) => {
        const puzzleCorrectAnswerId = puzzleCorrectAnswers.find(
          (puzzleCorrectAnswer) =>
            puzzleCorrectAnswer.stepId === userAnswer.stepId
        )?.videoId

        if (userAnswer.videoId !== puzzleCorrectAnswerId) {
          nbrWrongAnswers++
        }
      })

      return nbrWrongAnswers === 0 ? true : false
    },
  },

  actions: {
    init() {
      this.restorePuzzleData()
    },
    restorePuzzleData() {
      if (this.userAnswers.length !== 0) {
        return
      }

      this.retrieveLocalStorage()
    },
    retrieveLocalStorage() {
      const userAnswers = localStorage.getItem('puzzleUserAnswers')

      if (!userAnswers) {
        return
      }

      this.userAnswers = JSON.parse(userAnswers) as PuzzleUserAnswer[]
    },
    saveUserAnswers(userAnswers: PuzzleUserAnswer[]) {
      this.userAnswers = userAnswers

      localStorage.setItem('puzzleUserAnswers', JSON.stringify(userAnswers))
    },
    setCurrentVideoId(videoId: string | null) {
      this.currentVideoId = videoId
    },
    reset() {
      localStorage.removeItem('puzzleUserAnswers')

      this.userAnswers = []

      this.currentVideoId = null
    },
  },
})
